import { render, staticRenderFns } from "./FBLogin.vue?vue&type=template&id=d768339e&scoped=true&"
import script from "./FBLogin.vue?vue&type=script&lang=js&"
export * from "./FBLogin.vue?vue&type=script&lang=js&"
import style0 from "./FBLogin.vue?vue&type=style&index=0&id=d768339e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d768339e",
  null
  
)

export default component.exports